// import moment from 'moment'
import * as lockedAccountFormSchema from 'schemas/forms/LockedAccountForm'
import Heading from 'components/Heading'
import Modal from 'components/Modal'
import { validateAll } from 'utils/validators'
import React, { PropTypes, Component } from 'react'
import SubmitButton from 'components/SubmitButton'
import TextInput from 'components/Form/components/TextInput'
import Alert from 'components/Alert'
import styles from './LockedAccountDisplayForm.scss'

import {
  formUpdate,
  formInit,
  formSubmit,
  formReset,
} from 'actions/forms'

class LockedAccountDisplayForm extends Component {
  static propTypes = {
    accountsAndLoans: PropTypes.object,
    completeText: PropTypes.string,
    confirmation: PropTypes.bool,
    ctaText: PropTypes.string,
    data: PropTypes.object,
    description: PropTypes.string,
    dispatch: PropTypes.func.isRequired,
    forms: PropTypes.object.isRequired,
    handleFormSubmit: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    hide: PropTypes.func.isRequired,
    id: PropTypes.string,
    lockedAccountForm: PropTypes.object,
    modals: PropTypes.object.isRequired,
    show: PropTypes.bool,
    submittingText: PropTypes.string,
    title: PropTypes.string,
  }

  static defaultProps = {
    data: {},
    ctaText: 'Submit',
    completeText: 'Submitted',
    submittingText: 'Submitting',
    show: false,
    confirmation: false,
    accountsAndLoans: null,
    lockedAccountForm: null,
    id: '',
    title: '',
    description: '',
  }

  componentWillMount() {
    const { formFields } = lockedAccountFormSchema

    const formData = {
      formFields,
      data: this.props.data || null,
    }

    this.props.dispatch(formInit(this.props.id, formData))
  }

  componentWillReceiveProps(nextProps) {
    const modalCreated = this.props.modals.bankTransferForm
    const modalChanged = modalCreated && nextProps.modals.bankTransferForm.show !== this.props.modals.bankTransferForm.show
    const modalNotVisible = modalCreated && !nextProps.modals.bankTransferForm.show
    const modalVisible = modalCreated && nextProps.modals.bankTransferForm.show
    const dataChanged = nextProps.data !== this.props.data

    if (modalChanged && modalNotVisible) {
      this.props.dispatch(formReset(this.props.id))
    }

    if (modalChanged && modalVisible) {
      // preload data from BED if needed
    }
  }

  _schema = () => {
    const obj = {}
    lockedAccountFormSchema.formFields.forEach((field) => {
      obj[field.name] = field
    })
    return obj
  }

  _hide = () => {
    // this.props.dispatch(displayForm(false))
    this.props.hide(this.props.id)
    this.props.dispatch(formReset(this.props.id))
  }

  _handleSubmit = (e) => {
    e.preventDefault()
    const values = this.props.forms[this.props.id]
    const data = {}
    Object.keys(values).forEach((key) => {
      if (key.indexOf('_') < 0) {
        data[key] = values[key].value
      }
    })

    // Validate all the forms fields and return any errors
    const errors = validateAll(lockedAccountFormSchema.requiredFields, this.props.forms[this.props.id])

    // Check if form has errors
    if (errors.length > 0) {
      // If form has errors handle them
      errors.forEach((errObj) => {
        this._handleError(errObj, errObj.name)
      })
    } else {
      // If form has no errors, pass the serialized form field for submit and set the form to submit.
      // append or map existing data
      this.props.dispatch(formSubmit(this.props.id))
      this.props.handleSubmit(data)
    }
  }

  // Takes an error object for a field and updates the state accordingly
  _handleError(errorObj, stateKey) {
    // Set new state value for field and update state
    const stateValue = {
      data: {
        focus: false,
        error: (errorObj.valid) ? '' : errorObj.error,
        valid: errorObj.valid,
      },
      field: stateKey,
    }
    this._handleState(stateValue)
  }

  _handleState = (stateValue) => {
    this.props.dispatch(formUpdate(this.props.id, stateValue))
  }

  _handleValidation = (name) => {
    const stateValue = {
      field: name,
      data: {
        focus: false,
      },
    }

    this.props.dispatch(formUpdate(this.props.id, stateValue))
  }

  _handleFocus = (name) => {
    // Create state value obj
    const stateValue = {
      field: name,
      data: {
        focus: true,
      },
    }

    this.props.dispatch(formUpdate(this.props.id, stateValue))
  }

  _handleAutoComplete = (name, value) => {
    this._handleChange(name, value)
  }

  // Handle Changes on form elements
  _handleChange = (name, value) => {
    /*
      Create state value obj
      Reset error handling (Stops error check on focus changes)
    */
    const stateValue = {
      field: name,
      data: {
        value,
        error: '',
        valid: true,
      },
    }

    // Pass state value and handle state
    this.props.dispatch(formUpdate(this.props.id, stateValue))
  }

  canSubmit = () => {
    const form = this.props.forms[this.props.id]
    return form.account.value
  }

  render() {
    const {
      ctaText,
      completeText,
      submittingText,
      title,
      dispatch,
      modals,
      description,
    } = this.props
    const schema = this._schema()
    const form = this.props.forms[this.props.id]
    const disable = (form && form._isPosting)
    const forceClose = (form && form._hasCompleted)
    // const formHasFetched = this.props.hasFetched
    return (
      <Modal
        className={styles.bg}
        disable={disable}
        dispatch={dispatch}
        forceClose={forceClose}
        id="lockedAccountForm"
        modals={modals}
        onClose={this._hide}
      >
        <div className={styles.base}>
          <Heading className={styles.title} size="large">
            {title}
          </Heading>
          <p className={styles.content}>{description}</p>
          <Alert type="info">
          Account added will be locked for Partner to select on the Transfer Request form
          </Alert>
          {form &&
          <form
            className={styles.form}
            id={this.props.id}
            noValidate="novalidate"
            onSubmit={this._handleSubmit}
          >
            <div className={styles.sectionHeader} />
            <fieldset>
              <ul>
                <li>
                  <TextInput
                    {...schema.account}
                    handleChange={this._handleChange}
                    onBlur={this._handleValidation}
                    onFocus={this._handleFocus}
                    text={form.account.value}
                  />
                </li>
              </ul>
            </fieldset>
            <br /><br />
            <div className={styles.footer}>
              <SubmitButton
                complete={this.props.forms[this.props.id]._isComplete}
                completeText={completeText} // Add validation rules
                disabled={!this.canSubmit()}
                isLarge
                submitting={this.props.forms[this.props.id]._isPosting}
                submittingText={submittingText}
              >
                {ctaText}
              </SubmitButton>
            </div>
          </form>
        }
        </div>
      </Modal>
    )
  }
}

export default LockedAccountDisplayForm



// WEBPACK FOOTER //
// ./src/views/AccountsAndLoans/LockedAccountDisplayForm.js